import { render, staticRenderFns } from "./ReturnSalesListFunc.vue?vue&type=template&id=255b2943&scoped=true"
import script from "./ReturnSalesListFunc.vue?vue&type=script&lang=js"
export * from "./ReturnSalesListFunc.vue?vue&type=script&lang=js"
import style0 from "./ReturnSalesListFunc.vue?vue&type=style&index=0&id=255b2943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b2943",
  null
  
)

export default component.exports